import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {chatsRoutesPath} from './path';

const ChatsPage = Loadable(
  lazy(() => import('@src/pages/Chats' /* webpackChunkName: "chats-page" */)),
);
const SupportChatsPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/SupportChat/SupportChat' /* webpackChunkName: "support-chats-page" */
      ),
  ),
);
const NewChatsPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/NewChat/NewChat' /* webpackChunkName: "new-chats-page" */
      ),
  ),
);

export const chatsRoutes = [
  {
    element: <ChatsPage />,
    path: chatsRoutesPath.chats.$path(),
  },
  {
    element: <SupportChatsPage />,
    path: chatsRoutesPath.supportChats.$path(),
  },
  {
    element: <NewChatsPage />,
    path: chatsRoutesPath.chats.new.$path(),
  },
] satisfies RouteConfig[];
